import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Bullet Camera",
        price: 50,
        disprice: 40,
        stock: 15,
        content:
            "Enhance your security with our high-definition Bullet Camera, designed for outdoor and indoor surveillance with superior clarity and durability.",
        description:
            "Our Bullet Camera provides crystal-clear video, night vision, and weather-resistant housing for reliable security. Equipped with motion detection and remote monitoring, it ensures round-the-clock protection.",
        category: ["Surveillance Equipment", "Smart Security"],
        tags: ["Security", "Camera", "System"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "1080p Full HD" },
            { id: 2, title: "Night Vision", content: "Up to 100ft IR Night Vision" },
            { id: 3, title: "Weatherproof", content: "IP67 Rated for All-Weather Use" },
            { id: 4, title: "Connectivity", content: "Wired & Wireless Options" },
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "James Miller",
                date: "March 15, 2025",
                rating: 5,
                content: "Excellent camera quality with smooth night vision. Works great for outdoor security!",
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Sophia Lee",
                date: "March 20, 2025",
                rating: 4.8,
                content: "The motion detection feature is very accurate, and the installation was simple. Highly recommended!",
            },
        ],
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Smart Lock",
        price: 80,
        disprice: 65,
        stock: 20,
        content:
            "Upgrade your security with our Smart Lock, offering keyless entry, remote access, and advanced encryption for ultimate protection.",
        description:
            "Our Smart Lock provides enhanced security with fingerprint recognition, PIN code access, and mobile app control. Built with high-grade materials, it ensures reliable and secure door access management.",
        category: ["Access Control", "Smart Security"],
        tags: ["Smart", "Lock", "Access"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Access Methods", content: "Fingerprint, PIN Code, Mobile App, Key" },
            { id: 2, title: "Connectivity", content: "Bluetooth 5.0 & Wi-Fi" },
            { id: 3, title: "Battery Life", content: "Up to 1 Year (Rechargeable)" },
            { id: 4, title: "Security Features", content: "Anti-Tamper Alarm & Auto Locking" },
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Michael Roberts",
                date: "March 18, 2025",
                rating: 5,
                content: "Easy to install and works flawlessly with my phone. The fingerprint sensor is very fast!",
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Olivia Johnson",
                date: "March 22, 2025",
                rating: 4.9,
                content: "Great security features and smooth integration with my smart home system. Highly recommend!",
            },
        ],
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Modern Camera",
        price: 120,
        disprice: 99,
        stock: 15,
        content:
            "Enhance security with our Modern Camera, featuring high-resolution video, night vision, and smart motion detection.",
        description:
            "Our Modern Camera delivers crystal-clear 1080p HD video with wide-angle coverage. Equipped with AI-powered motion detection, two-way audio, and remote access, it ensures reliable surveillance for homes and businesses.",
        category: ["Surveillance Equipment", "Home Automation"],
        tags: ["Camera", "Smart", "Security"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "1080p Full HD" },
            { id: 2, title: "Night Vision", content: "Infrared up to 30ft" },
            { id: 3, title: "Connectivity", content: "Wi-Fi & Ethernet" },
            { id: 4, title: "Storage Options", content: "Cloud & SD Card Support" },
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Ethan Davis",
                date: "April 10, 2025",
                rating: 5,
                content: "Superb video quality and motion alerts work flawlessly. Highly recommended for security!",
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Sophia Lee",
                date: "April 15, 2025",
                rating: 4.8,
                content: "Easy to set up and provides clear footage. The night vision is excellent!",
            },
        ],
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Smart Thermostat",
        price: 130,
        disprice: 110,
        stock: 20,
        content:
            "Optimize your home's climate control with our Smart Thermostat, featuring remote access, energy-saving automation, and smart scheduling.",
        description:
            "Our Smart Thermostat provides precise temperature control with AI-driven automation. It learns your preferences, integrates with smart home systems, and reduces energy costs while keeping your space comfortable.",
        category: ["Home Automation", "Smart Security"],
        tags: ["Smart", "Sensor", "System"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Compatibility", content: "Works with Alexa, Google Assistant, and Apple HomeKit" },
            { id: 2, title: "Temperature Control", content: "Remote control via mobile app" },
            { id: 3, title: "Energy Efficiency", content: "AI-driven scheduling to save on heating and cooling" },
            { id: 4, title: "Installation", content: "Easy DIY setup with step-by-step guidance" },
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Daniel Carter",
                date: "May 5, 2025",
                rating: 5,
                content: "Great thermostat! I love the automation and remote access features. My energy bill is lower too!",
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Olivia Martinez",
                date: "May 10, 2025",
                rating: 4.9,
                content: "Sleek design, easy to install, and works flawlessly with my smart home system.",
            },
        ],
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Dome Camera",
        price: 80,
        disprice: 65,
        stock: 15,
        content:
            "Enhance security with our high-definition Dome Camera, designed for 24/7 surveillance with a wide field of view and night vision.",
        description:
            "Our Dome Camera offers superior image quality, motion detection, and infrared night vision. Its discreet design makes it ideal for both indoor and outdoor security, ensuring complete monitoring of your premises.",
        category: ["Surveillance Equipment", "Smart Security"],
        tags: ["Camera", "Security", "System"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "1080p Full HD" },
            { id: 2, title: "Night Vision", content: "Infrared LED up to 50ft" },
            { id: 3, title: "Motion Detection", content: "Real-time alerts via mobile app" },
            { id: 4, title: "Weatherproof", content: "IP66-rated for outdoor use" },
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "James Richardson",
                date: "March 15, 2025",
                rating: 5,
                content: "Crystal-clear video quality, and the motion detection works perfectly. Highly recommend for home security!",
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Sophia Lee",
                date: "March 20, 2025",
                rating: 4.8,
                content: "Great camera! Easy to install and provides excellent night vision. Feels very secure now.",
            },
        ],
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Access Control",
        price: 120,
        disprice: 100,
        stock: 20,
        content:
            "Enhance security with our advanced Access Control system, designed to manage and restrict access to secure areas efficiently.",
        description:
            "Our Access Control system provides keyless entry, multi-user authentication, and remote access management. Perfect for businesses and residential buildings, it ensures only authorized personnel can enter restricted areas.",
        category: ["Access Control", "Smart Security"],
        tags: ["Access", "Control", "Security"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Authentication", content: "Biometric, PIN, RFID" },
            { id: 2, title: "Connectivity", content: "Wi-Fi & Bluetooth enabled" },
            { id: 3, title: "Remote Control", content: "Manage access via mobile app" },
            { id: 4, title: "Security Level", content: "AES-256 encryption for data protection" },
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Michael Carter",
                date: "March 18, 2025",
                rating: 5,
                content: "Highly reliable and easy to set up! Great for controlling access to my office securely.",
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Linda Wilson",
                date: "March 22, 2025",
                rating: 4.9,
                content: "The biometric authentication works flawlessly, and remote access is a great feature!",
            },
        ],
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Fire Extinguisher",
        price: 60,
        disprice: 50,
        stock: 30,
        content:
            "Ensure safety with our high-quality Fire Extinguisher, designed for quick response to fire emergencies in homes, offices, and industrial areas.",
        description:
            "Our Fire Extinguisher is compact, easy to use, and suitable for multiple fire types, including electrical, grease, and chemical fires. Ideal for residential, commercial, and industrial safety compliance.",
        category: ["Fire Safety", "Home Automation"],
        tags: ["Fire", "Safety", "System"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Fire Type", content: "Class A, B, C, and Electrical Fires" },
            { id: 2, title: "Capacity", content: "5 lbs, 10 lbs, 15 lbs options" },
            { id: 3, title: "Discharge Time", content: "10-15 seconds" },
            { id: 4, title: "Certifications", content: "UL Listed, NFPA Compliant" },
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "John Smith",
                date: "March 25, 2025",
                rating: 5,
                content: "Reliable and easy to use. A must-have for every home and office!",
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Sarah Lewis",
                date: "March 27, 2025",
                rating: 4.8,
                content: "Great quality and compact design. It provides peace of mind in case of emergencies.",
            },
        ],
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Door Intercom",
        price: 120,
        disprice: 100,
        stock: 20,
        content:
            "Enhance security and communication with our advanced Door Intercom system, designed for residential and commercial use.",
        description:
            "Our Door Intercom system provides clear two-way audio, video surveillance, and remote access control. Ideal for homes, offices, and apartment buildings, ensuring safe and convenient visitor management.",
        category: ["Access Control", "Smart Security"],
        tags: ["Access", "Control", "System"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Audio/Video", content: "Two-way communication with HD video" },
            { id: 2, title: "Connectivity", content: "Wired & Wireless Options" },
            { id: 3, title: "Remote Access", content: "Compatible with mobile apps" },
            { id: 4, title: "Installation", content: "Wall-mounted or standalone" },
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Michael Brown",
                date: "March 26, 2025",
                rating: 5,
                content: "Crystal-clear audio and video. A must-have for any security-conscious home or office.",
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Jessica Lee",
                date: "March 28, 2025",
                rating: 4.9,
                content: "Easy to install and provides excellent security. The mobile app integration is a game-changer!",
            },
        ],
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Fire Alarm",
        price: 80,
        disprice: 65,
        stock: 30,
        content:
            "Ensure safety with our high-performance Fire Alarm system, designed for rapid smoke and heat detection.",
        description:
            "Our Fire Alarm system provides early warning in case of fire emergencies. With advanced sensors and loud alerts, it ensures quick evacuation and response, making it ideal for homes, offices, and commercial buildings.",
        category: ["Fire Safety", "Home Automation"],
        tags: ["Fire", "Alarm", "Security"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Detection", content: "Smoke and heat sensors for early warning" },
            { id: 2, title: "Alarm Type", content: "Loud 85dB siren with flashing LED" },
            { id: 3, title: "Connectivity", content: "Wired & Wireless Options" },
            { id: 4, title: "Power Source", content: "Battery-powered with backup option" },
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Daniel Smith",
                date: "March 26, 2025",
                rating: 5,
                content: "Reliable and loud alarm. Provides great peace of mind for fire safety.",
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Sophia Martinez",
                date: "March 28, 2025",
                rating: 4.8,
                content: "Easy to install and works efficiently. A must-have for every building!",
            },
        ],
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Security Cam",
        price: 100,
        disprice: 85,
        stock: 25,
        content:
            "Enhance surveillance with our high-resolution Security Cam, designed for real-time monitoring and safety.",
        description:
            "Our Security Cam offers crystal-clear video recording with night vision and motion detection. Ideal for homes, businesses, and offices, it ensures round-the-clock protection with remote access and smart alerts.",
        category: ["Surveillance Equipment", "Smart Security"],
        tags: ["Security", "Camera", "System"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "1080p Full HD with Night Vision" },
            { id: 2, title: "Connectivity", content: "Wi-Fi & Ethernet Support" },
            { id: 3, title: "Features", content: "Motion Detection & Smart Alerts" },
            { id: 4, title: "Storage", content: "Cloud & Local Storage Options" },
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Michael Johnson",
                date: "March 27, 2025",
                rating: 5,
                content: "Great camera with sharp image quality and smooth remote access.",
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Anna Williams",
                date: "March 29, 2025",
                rating: 4.7,
                content: "Easy setup and reliable security features. Definitely worth it!",
            },
        ],
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Digital Lock",
        price: 120,
        disprice: 99,
        stock: 15,
        content:
            "Secure your property with our advanced Digital Lock, offering keyless entry and enhanced security features.",
        description:
            "Our Digital Lock provides a smart and convenient way to protect your home or office. With multiple access options, including PIN codes, RFID cards, and smartphone control, it ensures maximum security with ease of use.",
        category: ["Access Control", "Smart Security"],
        tags: ["Smart", "Lock", "Access"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Access Methods", content: "PIN Code, RFID Card, Mobile App" },
            { id: 2, title: "Connectivity", content: "Wi-Fi & Bluetooth Enabled" },
            { id: 3, title: "Security Features", content: "Tamper Alarm & Auto Locking" },
            { id: 4, title: "Power Source", content: "Battery Operated with Backup Key" },
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "John Smith",
                date: "March 27, 2025",
                rating: 5,
                content: "Excellent security upgrade! The keyless entry is super convenient.",
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Sarah Miller",
                date: "March 29, 2025",
                rating: 4.8,
                content: "Easy to install and provides great security. Highly recommend!",
            },
        ],
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "HD Camera",
        price: 80,
        disprice: 65,
        stock: 20,
        content:
            "Enhance your surveillance with our high-definition HD Camera, delivering crystal-clear video quality for better security monitoring.",
        description:
            "Our HD Camera offers superior image clarity with night vision and motion detection. Perfect for both indoor and outdoor security applications, it ensures 24/7 surveillance with remote access via mobile apps.",
        category: ["Surveillance Equipment", "Smart Security"],
        tags: ["Camera", "Security", "System"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "1080p Full HD" },
            { id: 2, title: "Night Vision", content: "Infrared up to 30m" },
            { id: 3, title: "Connectivity", content: "Wi-Fi & Ethernet" },
            { id: 4, title: "Special Features", content: "Motion Detection & Remote Viewing" },
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Michael Johnson",
                date: "March 28, 2025",
                rating: 5,
                content: "Crystal-clear footage and easy installation. Great value for money!",
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Lisa Carter",
                date: "March 30, 2025",
                rating: 4.9,
                content: "The night vision works perfectly, and remote access is super convenient.",
            },
        ],
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Smart Sensor",
        price: 50,
        disprice: 40,
        stock: 30,
        content:
            "Enhance security with our Smart Sensor, designed for real-time motion detection and instant alerts to keep your property safe.",
        description:
            "Our Smart Sensor offers advanced motion detection, real-time notifications, and seamless integration with security systems. Ideal for homes and businesses, it provides an extra layer of protection with smart automation capabilities.",
        category: ["Home Automation", "Smart Security"],
        tags: ["Smart", "Sensor", "Security"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Detection Type", content: "Motion & Sound" },
            { id: 2, title: "Connectivity", content: "Wi-Fi & Zigbee" },
            { id: 3, title: "Alert System", content: "Instant Mobile Notifications" },
            { id: 4, title: "Power", content: "Battery & Wired Options" },
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "James Wilson",
                date: "April 2, 2025",
                rating: 5,
                content: "Works flawlessly! The instant alerts give me peace of mind.",
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Sophia Lee",
                date: "April 5, 2025",
                rating: 4.8,
                content: "Easy to set up and integrates well with my home security system.",
            },
        ],
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Dome Cam",
        price: 60,
        disprice: 50,
        stock: 25,
        content:
            "Upgrade your security with our high-definition Dome Cam, offering wide-angle surveillance and night vision for enhanced protection.",
        description:
            "Our Dome Cam is designed for superior surveillance with HD resolution, infrared night vision, and motion detection. Ideal for both indoor and outdoor security, it ensures clear footage in any lighting conditions.",
        category: ["Surveillance Equipment", "Smart Security"],
        tags: ["Camera", "Security", "System"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "1080p Full HD" },
            { id: 2, title: "Night Vision", content: "Infrared up to 30m" },
            { id: 3, title: "Connectivity", content: "Wired & Wireless Options" },
            { id: 4, title: "Weatherproof", content: "IP66 Rated for Outdoor Use" },
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Mark Johnson",
                date: "April 10, 2025",
                rating: 5,
                content: "Excellent camera with clear footage and reliable night vision!",
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Lisa Brown",
                date: "April 15, 2025",
                rating: 4.7,
                content: "Perfect for home security, easy to install and great image quality.",
            },
        ],
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Entry Control",
        price: 80,
        disprice: 65,
        stock: 20,
        content:
            "Enhance security with our advanced Entry Control system, providing controlled access to restricted areas.",
        description:
            "Our Entry Control system is designed for high security, offering biometric authentication, keycard access, and remote monitoring. Ideal for businesses, residential buildings, and high-security areas.",
        category: ["Access Control", "Smart Security"],
        tags: ["Access", "Control", "Security"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Authentication", content: "Biometric, Keycard, PIN Code" },
            { id: 2, title: "Remote Access", content: "Manage via Mobile App" },
            { id: 3, title: "Integration", content: "Compatible with CCTV & Alarm Systems" },
            { id: 4, title: "Security Level", content: "Advanced Encryption & Multi-Layer Protection" },
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "John Carter",
                date: "March 5, 2025",
                rating: 5,
                content: "Great system! Easy to use and adds an extra layer of security to my office.",
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Sophia Miller",
                date: "March 12, 2025",
                rating: 4.8,
                content: "Reliable and integrates well with my CCTV setup. Highly recommended!",
            },
        ],
    }
];

export default products;